import React from "react"
import {TextModel} from "models/Text"
import StandardMenuButton, {StyledMenuIcon} from "./components"
import env from "../../../../../../config/env"

interface StandardMenuButtonProps {
    text: TextModel
    disableIcon: boolean
    anchorRef: React.RefObject<HTMLButtonElement>
    open: boolean
    setOpen: (value: React.SetStateAction<boolean>) => void
    buttonText: string
}

const StandardMenuButtonComponent = ({
    text,
    disableIcon,
    anchorRef,
    open,
    setOpen,
    buttonText,
}: StandardMenuButtonProps) => {
    const handleToggle = () => {
        setOpen(prev => !prev)
    }

    return (
        <StandardMenuButton
            aria-controls={open ? "menu-list-grow" : undefined}
            aria-haspopup="true"
            aria-describedby={open ? "styled-options-menu" : undefined}
            onClick={handleToggle}
            ref={anchorRef}
            disableRipple
            disableElevation
            variant="text"
            data-testid={`plp-menu-button-${buttonText.toLowerCase()}`}
        >
            {!open && !disableIcon && (
                <StyledMenuIcon
                    src={`${env.REACT_APP_BLOB_STORAGE_PATH}/icons/shared/next_sort_mobile_menu.svg`}
                    alt={text.assetsAlt.closeIcon}
                    data-testid="plp-menu-button-icon"
                />
            )}
            <div>{open ? text.labels.close : buttonText}</div>
        </StandardMenuButton>
    )
}

export default StandardMenuButtonComponent
